export const GET_BILLS_REQUEST = 'GET_BILLS_REQUEST';
export const VIEW_BILL_REQUEST = 'VIEW_BILL_REQUEST';
export const DOWNLOAD_BILL_REQUEST = 'DOWNLOAD_BILL_REQUEST';
export const LOAD_BILL_REQUEST = 'LOAD_BILL_REQUEST';
export const LOAD_BILL_SUCCESS = 'LOAD_BILL_SUCCESS';
export const LOAD_BILL_FAILURE = 'LOAD_BILL_FAILURE';

export const GET_BILLS_SUCCESS = 'GET_BILLS_SUCCESS';
export const GET_BILLS_FAILURE = 'GET_BILLS_FAILURE';

export const VIEW_PAYMENT_RECEIPT_REQUEST = 'VIEW_PAYMENT_RECEIPT_REQUEST';